export const dataToRow = (item) => ({
  id: item.code,
  cryptoAssetCode: item.code,
  isEnabled: !!item?.merchantPromotionNetworkFee,
})
